import { CalculationKeynameEnum } from '../enums/calculations/calculation-keyname.enum';

export class ClientQuestionnaireConvertedToCalculationResponse {
  calculationId: string;

  calculationKeyname: CalculationKeynameEnum;
}